import { Alert, Button, Card, Col, Form, Row, Spinner } from "react-bootstrap";
import {
  EnumPoljaEvidencije,
  IAddress,
  ILocalStorage,
  IRecordPointClass,
} from "../../../redux/interfaces";
import {
  FIND_RECORD_POINT_BY_NAME,
  GET_RECORD_POINTS_BY_BRANCH_ID,
  GET_USERS_BY_ID_QUERY,
} from "../../../graphql/evidencijePoPotrebi";
import { FormInput, MobileSelect } from "../../../components";
import {
  IPDFBranch,
  generatePDF,
} from "../ListaEvidencija/components/ListaEvidencijaPdfDocument";
import { ItemType, convertToItemType } from "../ListaKompanija/ListaKompanija";
import { useEffect, useState } from "react";
import { useLazyQuery, useQuery } from "@apollo/client";

import { GET_BRANCHES_BY_USER } from "../../../graphql/dodavanjekorisnika";
import { GET_RECORD_POINT_TREES } from "../../../graphql/tackeprimjene";
import { IRecordPointTreesJSON } from "../../KatalogEvidencija/components/Step3/TPEvidencije";
import { Link } from "react-router-dom";
import { ListaEvidencijaResourcesBSInterface } from "../ListaEvidencija/ListaEvidencija.resources";
import classNames from "classnames";
import config from "../../../config";
import { formatDate } from "../ListaEvidencija/helpers/FormatDate";
import { generatePDFList } from "../ListaEvidencija/components/LEPdfDocumentList";
import { useForm } from "react-hook-form";
import { useTypedResource } from "../../../i18n/languagehandler";

interface IBranchElement {
  branchId: number;
  name: string;
  address: IAddress;
}

interface QueryRecordPointsByName {
  findRecordPointByName: IRecordPointClass[];
}

interface QueryRecordPointsByBranchId {
  recordPointsByBranchId: IRecordPointClass[];
}

interface RecordPointTree {
  recordPointTreeId: number;
  createdAt: string;
  updatedAt: string;
  status: boolean;
  name: string;
  parent: string | null; // If nullable in the server schema
  orderNumber: number;
}

interface IUsersQuery {
  users: [
    {
      userId: number;
      potpis: string;
      fullName: string;
    }
  ];
}

interface FormattedItem {
  id: number;
  text: string;
  checked: boolean;
  children?: FormattedItem[];
}

type BranchOption = {
  label: string;
  value: string;
};

const createCategoriesFromData = (data: IBranchElement[]) => {
  return (
    data &&
    data.map((branch: any) => ({
      value: branch.branchId.toString(),
      label: branch.name,
    }))
  );
};

interface IBranchesQuery {
  findBranchesByUserId: IBranchElement[];
}

type FormData = {
  branch: BranchOption;
};

interface IRecordPointTrees {
  recordPointTrees: RecordPointTree[];
}

interface TackePrimjene {
  Id: number;
  NazivTacke: string;
  Parent: string;
  Order: string;
  Checked: boolean;
}

function convertArrayToJSON(arr: any[]): IRecordPointTreesJSON {
  const convertedArray: TackePrimjene[] = arr.map((item) => ({
    Id: item.recordPointTreeId,
    NazivTacke: item.name,
    Parent: item.parent, // Assuming there is a property named "parentId" in the object
    Order: item.orderNumber, // Assuming there is a property named "order" in the object
    Checked: false,
  }));

  return { TackePrimjene: convertedArray };
}

function formatTackePrimjeneToTree(items: TackePrimjene[]): FormattedItem[] {
  const map: { [key: string]: FormattedItem } = {};

  // Create a map of TackePrimjene items with their NazivTacke as keys
  for (const item of items) {
    map[item.NazivTacke] = {
      id: item.Id,
      text: item.NazivTacke,
      checked: item.Checked,
    };
  }
  // Build the tree structure using the Parent property
  const tree: FormattedItem[] = [];
  for (const item of items) {
    const current = map[item.NazivTacke];
    const parent = map[item.Parent || ""];

    if (parent) {
      if (!parent.children) {
        parent.children = [];
      }
      parent.children.push(current);
    } else {
      tree.push(current);
    }
  }

  return tree;
}

interface GroupedPoints {
  [key: string]: IRecordPointClass[];
}

const groupByPointName = (points: IRecordPointClass[]): GroupedPoints => {
  // Sort the points by createdAt in ascending order
  points.sort(
    (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
  );

  return points.reduce((acc: GroupedPoints, point: IRecordPointClass) => {
    if (!acc[point.name]) {
      acc[point.name] = [];
    }
    acc[point.name].push(point);
    return acc;
  }, {});
};

export const getFirstDayOfCurrentMonth = (): Date => {
  const currentDate = new Date();
  // Set to the first day of the current month
  return new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
};

/**
 * Returns a Date object representing the last day of the current month
 */
export const getLastDayOfCurrentMonth = (): Date => {
  const currentDate = new Date();
  // Set to the first day of the next month, then subtract a day to get the last day of the current month
  return new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
};

export function formatStateDates(dateString: string): string {
  const date = new Date(dateString);

  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-indexed
  const year = date.getFullYear();

  return `${year}-${month}-${day}`;
}

function ListaSanEvd() {
  const [startDate, setstartDate] = useState<Date>(getFirstDayOfCurrentMonth());
  const [endDate, setendDate] = useState<Date>(getLastDayOfCurrentMonth());

  const res =
    useTypedResource<ListaEvidencijaResourcesBSInterface>("listaEvidencija");
  const [categories, setCategories] = useState<BranchOption[]>([]);
  const [branchState, setbranchState] = useState<BranchOption | null>();
  const [recordPointName, setRecordPointName] = useState<string | null>();
  const [showItems, setShowItems] = useState<boolean>(false);
  const [showItemsLista, setShowItemsLista] = useState<boolean>(false);
  const [showSanEvd, setshowSanEvd] = useState<boolean>(false);
  const [sanRequested, setSanRequested] = useState<boolean>(false);
  const [recordFieldsTypes, setRecordFieldsTypes] = useState<
    { recordTraceConfigId: number; title?: string; revizija?: string }[]
  >([]);
  const [recordFieldsListTypes, setRecordFieldsListTypes] = useState<
    { recordTraceConfigId: number; title?: string; revizija?: string }[]
  >([]);
  const [sanEvdsList, setsanEvdsList] = useState<IRecordPointClass[]>([]);

  const [selectedRecordField, setSelectedRecordField] =
    useState<EnumPoljaEvidencije | null>(null);
  const [selectedRecordFieldList, setSelectedRecordFieldList] =
    useState<EnumPoljaEvidencije | null>(null);
  const [recordTraceConfigIdState, setrecordTraceConfigIdState] = useState<
    number | null
  >(null);
  const [recordPointsState, setRecordPointsState] = useState<
    IRecordPointClass[]
  >([]);
  // const [evidencijeState, setevidencijeState] = useState<IRecordPointClass[]>(
  //   []
  // );

  const storedUser = localStorage.getItem("user");
  const [items, setItems] = useState<ItemType | undefined>();
  let person: ILocalStorage | null = null;
  if (storedUser) {
    person = JSON.parse(storedUser);
  }

  const {
    loading: queryLoading,
    refetch: queryRefetch,
    data: queryData,
    error: errorQuery,
  } = useQuery<IBranchesQuery>(GET_BRANCHES_BY_USER, {
    variables: { userId: Number(person?.user.userId) },
    skip: person?.user.userId === 0,
  });

  function groupByRecordTraceConfigId(recordPoints: IRecordPointClass[]): {
    recordTraceConfigId: number;
    title?: string;
    revizija?: string;
  }[] {
    const result: {
      recordTraceConfigId: number;
      title?: string;
      revizija?: string;
    }[] = [];

    const seenConfigIds = new Set<number>();
    recordPoints.forEach((point) => {
      const config = point.RecordTraceConfig;
      const configId = Number(config?.recordTraceConfigId);
      const title = config?.title;
      const revizija = config?.revizija;
      const recordFields = config?.recordFields;

      // Exclude SanEvd types
      if (
        typeof configId === "number" &&
        !seenConfigIds.has(configId) &&
        recordFields !== EnumPoljaEvidencije.SanEvd_V1 // <-- Exclude SanEvd
      ) {
        seenConfigIds.add(configId);
        result.push({ recordTraceConfigId: configId, title, revizija });
      }
    });

    return result;
  }

  function separateEvdTypes(recordPoints: IRecordPointClass[]) {
    const groupedRecordPoints = groupByRecordTraceConfigId(recordPoints);
    setRecordFieldsListTypes(groupedRecordPoints);
    // setevidencijeState(recordPoints);
  }

  const [
    fetchByBranch,
    {
      loading: queryEvidencijeLoading,
      data: queryEvidencijeData,
      error: errorById,
    },
  ] = useLazyQuery<QueryRecordPointsByBranchId>(
    GET_RECORD_POINTS_BY_BRANCH_ID,
    { fetchPolicy: "network-only" }
  );

  // Keep automatic query for general evidencije list to populate evidencijeState
  const {
    refetch: generalRefetch,
    loading: generalLoading,
    data: generalData,
  } = useQuery<QueryRecordPointsByBranchId>(GET_RECORD_POINTS_BY_BRANCH_ID, {
    variables: {
      branchId: branchState?.value ? Number(branchState?.value) : 0,
    },
    skip: !branchState?.value,
  });

  const {
    loading: queryRPByNameLoading,
    refetch: queryRPByNameRefetch,
    data: queryRPByNameData,
    error: errorByName,
  } = useQuery<QueryRecordPointsByName>(FIND_RECORD_POINT_BY_NAME, {
    variables: {
      name: recordPointName,
      startDate: startDate,
      endDate: endDate,
      branchId: branchState?.value ? Number(branchState?.value) : 0,
    },
    skip: !recordPointName || recordPointName.trim() === "",
  });

  const {
    loading: loadingRPT,
    refetch: refetchRPT,
    data: dataRPT,
    error: errorTree,
  } = useQuery<IRecordPointTrees>(GET_RECORD_POINT_TREES, {
    variables: {
      branchId: branchState?.value
        ? branchState?.value && parseInt(branchState?.value)
        : 0,
    },
    skip: !branchState?.value,
  });

  const sortByDateTime = (
    a: IRecordPointClass,
    b: IRecordPointClass
  ): number => {
    const dateA = new Date(a.createdAt);
    const dateB = new Date(b.createdAt);

    return dateB.getTime() - dateA.getTime(); // For descending order
  };

  useEffect(() => {
    if (!queryRPByNameLoading && queryRPByNameData) {
      const groupedRecordPoints = groupByRecordTraceConfigId(
        queryRPByNameData.findRecordPointByName
      );
      setRecordFieldsTypes(groupedRecordPoints);
      // setevidencijeState(queryRPByNameData.findRecordPointByName);

      setRecordPointsState(queryRPByNameData.findRecordPointByName);
      setFilteredRecordPoints(
        recordPointsState
          .filter(
            (point) =>
              point.RecordTraceConfig?.recordFields === selectedRecordField &&
              Number(point.RecordTraceConfig.recordTraceConfigId) ===
                recordTraceConfigIdState &&
              point.RecordTraceConfig.recordFields !==
                EnumPoljaEvidencije.SanEvd_V1
          )
          .sort(sortByDateTime)
      );
    }
  }, [
    queryRPByNameLoading,
    queryRPByNameData,
    recordPointsState,
    selectedRecordField,
    recordPointName,
    recordTraceConfigIdState,
  ]);

  // Populate evidencijeState for general lists (kept automatic)
  useEffect(() => {
    if (!generalLoading && generalData) {
      const list = generalData.recordPointsByBranchId;
      separateEvdTypes(list);
      setFilteredRecordPointsList(
        list
          .filter(
            (point) =>
              point.RecordTraceConfig?.recordFields ===
                selectedRecordFieldList &&
              Number(point.RecordTraceConfig.recordTraceConfigId) ===
                recordTraceConfigIdState &&
              point.RecordTraceConfig.recordFields !==
                EnumPoljaEvidencije.SanEvd_V1
          )
          .sort(sortByDateTime)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    generalLoading,
    generalData,
    selectedRecordFieldList,
    recordTraceConfigIdState,
  ]);

  // After SanEvd lazy fetch completes, compute SanEvd-only list
  useEffect(() => {
    if (!queryEvidencijeLoading && queryEvidencijeData) {
      const list = queryEvidencijeData.recordPointsByBranchId;
      const sanevd = list
        .filter(
          (point) =>
            point.RecordTraceConfig?.recordFields ===
            EnumPoljaEvidencije.SanEvd_V1
        )
        .sort(sortByDateTime);
      setsanEvdsList(sanevd);
    }
  }, [queryEvidencijeLoading, queryEvidencijeData]);

  useEffect(() => {
    refetchRPT();

    if (!loadingRPT && dataRPT) {
      if (dataRPT.recordPointTrees.length === 0) {
      } else {
        const jsonData: IRecordPointTreesJSON = convertArrayToJSON(
          dataRPT.recordPointTrees
        );

        const formattedItems: FormattedItem[] = formatTackePrimjeneToTree(
          jsonData.TackePrimjene
        );

        const itemTypes: ItemType[] = formattedItems.map((item) =>
          convertToItemType(item)
        );

        const xItem: ItemType = {
          label: "Lista definisanih tacaka",
          children: itemTypes,
        };
        setItems(xItem);
      }
    }
  }, [loadingRPT, dataRPT, refetchRPT]);

  useEffect(() => {
    queryRefetch();

    if (!queryLoading && queryData) {
      const newCategories = createCategoriesFromData(
        queryData.findBranchesByUserId
      );
      setCategories(newCategories);

      // Auto-select first item if no selection exists
      if (newCategories.length > 0 && !branchState) {
        setbranchState(newCategories[0]);
      }
    }
  }, [queryLoading, queryData, queryRefetch, branchState]);

  const { handleSubmit } = useForm<FormData>();

  const onSubmit = (data: FormData) => {};

  function handlebranchChange(value: null | BranchOption) {
    setbranchState(value);
  }

  async function getSanEvdOnly(branchId: string) {
    setShowItems(false);
    setShowItemsLista(false);
    setsanEvdsList([]);
    setshowSanEvd(true);
    setSanRequested(true);
    try {
      await fetchByBranch({
        variables: {
          branchId: Number(branchId),
          startDate: startDate,
          endDate: endDate,
        },
      });
      await generalRefetch({
        branchId: Number(branchId),
      });
    } catch (error) {
      console.error(error);
    }
  }

  function getRecordPoints(label: string) {
    setRecordPointName(label);

    queryRPByNameRefetch({
      name: label,
    }).catch((error) => {
      // Handle the error case
      console.error(error);
    });
  }

  const SiteMapMenu = ({ item }: { item: ItemType }) => {
    return (
      <ul>
        {(item.children || []).map((item, index) => (
          <SiteMapMenuItem key={index} item={item} />
        ))}
      </ul>
    );
  };

  const SiteMapMenuItem = ({ item }: { item: ItemType }) => {
    const { children } = item;
    const hasChildren = item && children && children.length;

    return (
      <li>
        <Link
          to="#"
          className={classNames(item.className)}
          onClick={() => getRecordPoints(item.label)}
        >
          {item.icon && <i className={classNames(item.icon, "me-1")}></i>}
          {item.label}
        </Link>
        {hasChildren && <SiteMapMenu item={item} />}
      </li>
    );
  };

  const [userIds, setUserIds] = useState<number[]>([]); // Replace with your array of userIds

  // Define your GraphQL query variables
  const variables = { userIds };

  // Use the useQuery hook to execute the GraphQL query
  const {
    loading,
    error,
    data: usersData,
    refetch: usersDataRefetch,
    error: errorUsers,
  } = useQuery<IUsersQuery>(GET_USERS_BY_ID_QUERY, {
    variables,
  });

  useEffect(() => {
    usersDataRefetch();
    if (!loading && !error && usersData) {
    }
  }, [loading, error, usersData, usersDataRefetch]);

  const handleDownloadPDF = () => {
    const branch = queryData?.findBranchesByUserId[0];

    if (branch?.address) {
      const branchPDF: IPDFBranch = {
        name: branch?.name ? branch?.name : "",
        address: branch?.address,
      };

      if (selectedRecordField) {
        generatePDF(
          filteredRecordPoints,
          branchPDF,
          res.pdfListaEvidencija,
          printRecordPoint(selectedRecordField),
          selectedRecordField,
          startDate,
          endDate,
        );
      }
    }
  };

  const handleDownloadPDFSanEvd = (sanList: IRecordPointClass[]) => {
    const branch = queryData?.findBranchesByUserId[0];
    if (!branch?.address) return;

    const branchPDF: IPDFBranch = {
      name: branch?.name || "",
      address: branch.address,
    };

    const toDownload = sanList
      .filter(
        (point) =>
          point &&
          point.RecordTraceConfig &&
          point.RecordTraceConfig.recordFields === EnumPoljaEvidencije.SanEvd_V1
      )
      .sort(sortByDateTime);

    if (!toDownload.length) {
      alert("Nema podataka za export.");
      return;
    }

    void generatePDFList(
      toDownload,
      branchPDF,
      res.pdfListaEvidencija,
      printRecordPoint(EnumPoljaEvidencije.SanEvd_V1),
      EnumPoljaEvidencije.SanEvd_V1,
      startDate,
      endDate,
    );
  };

  const handleDownloadPDFList = () => {
    const branch = queryData?.findBranchesByUserId[0];

    if (branch?.address) {
      const branchPDF: IPDFBranch = {
        name: branch?.name ? branch?.name : "",
        address: branch?.address,
      };

      if (selectedRecordFieldList) {
        void generatePDFList(
          filteredRecordPointsList,
          branchPDF,
          res.pdfListaEvidencija,
          printRecordPoint(selectedRecordFieldList),
          selectedRecordFieldList,
          startDate,
          endDate,
        );
      }
    }
  };

  const printRecordPoint = (recordPoint: EnumPoljaEvidencije) => {
    switch (recordPoint) {
      case EnumPoljaEvidencije.CIPO_V1:
        return res.poljaEvidencije.CIPO_V1;
      case EnumPoljaEvidencije.CIPP_V1:
        return res.poljaEvidencije.CIPP_V1;
      case EnumPoljaEvidencije.Dezinfekcija_V1:
        return res.poljaEvidencije.Dezinfekcija_V1;
      case EnumPoljaEvidencije.Dezinsekcija_V1:
        return res.poljaEvidencije.Dezinsekcija_V1;
      case EnumPoljaEvidencije.Dezinsekcija_Kontrola_V1:
        return res.poljaEvidencije.Dezinsekcija_Kontrola_V1;
      case EnumPoljaEvidencije.Dezinsekcija_Korekcija_V1:
        return res.poljaEvidencije.Dezinskecija_Korekcija_V1;
      case EnumPoljaEvidencije.Deratizacija_V1:
        return res.poljaEvidencije.Deratizacija_V1;
      case EnumPoljaEvidencije.Deratizacija_Korekcije_V1:
        return res.poljaEvidencije.Deratizacija_Korekcije_V1;
      case EnumPoljaEvidencije.Deratizacija_Kontrole_V1:
        return res.poljaEvidencije.Deratizacija_Kontrole_V1;
      case EnumPoljaEvidencije.DezSrEvd_V1:
        return res.poljaEvidencije.DezSr_V1;
      case EnumPoljaEvidencije.DobavljacEvd_V1:
        return res.poljaEvidencije.Dobavljac_V1;
      case EnumPoljaEvidencije.DostavaEvd_V1:
        return res.poljaEvidencije.Dostava_V1;
      case EnumPoljaEvidencije.EduZapEvd_V1:
        return res.poljaEvidencije.EduZap_V1;
      case EnumPoljaEvidencije.MolEvd_V1:
        return res.poljaEvidencije.Mol_V1;
      case EnumPoljaEvidencije.OpremaEvd_V1:
        return res.poljaEvidencije.Oprema_V1;
      case EnumPoljaEvidencije.OtpadEvd_V1:
        return res.poljaEvidencije.Otpad_V1;
      case EnumPoljaEvidencije.PrijemRobeEvd_V1:
        return res.poljaEvidencije.PrijemRobe_V1;
      case EnumPoljaEvidencije.TemperaturaEvd_V1:
        return res.poljaEvidencije.Temperatura_V1;
      case EnumPoljaEvidencije.TemperaturaOgranicenaEvd_V1:
        return res.poljaEvidencije.TemperaturaOgranicena_V1;
      case EnumPoljaEvidencije.TemperaturaOgranicenaKKTEvd_V1:
        return res.poljaEvidencije.TemperaturaOgranicenaKKT_V1;
      case EnumPoljaEvidencije.TemperaturaKKTProizvodiEvd_V1:
        return res.poljaEvidencije.TemperaturaKKTProizvodiEvd_V1;
      default:
        return "";
    }
  };

  const handleRecordPointClick = (recordField: {
    recordTraceConfigId: number;
    title?: string;
    revizija?: string;
  }) => {
    if (queryRPByNameData?.findRecordPointByName) {
      const filteredRps: IRecordPointClass[] = filterRecordPointsByConfigId(
        queryRPByNameData?.findRecordPointByName,
        recordField.recordTraceConfigId
      );

      if (filteredRps.length > 0) {
        const firstRecordPoint = filteredRps[0];
        setrecordTraceConfigIdState(
          Number(firstRecordPoint.RecordTraceConfig?.recordTraceConfigId)
        );
        const evdType = getEvdTypeFromRecordPoint(firstRecordPoint);
        if (evdType) {
          setSelectedRecordField(evdType);
        } else {
          // TODO: Handle if no type found
        }
      } else {
        //TODO: handle if none filtered
      }
    }
  };

  function getEvdTypeFromRecordPoint(
    recordPoint: IRecordPointClass
  ): EnumPoljaEvidencije | null {
    if (recordPoint.CIPOEvd && recordPoint.CIPOEvd.length > 0)
      return EnumPoljaEvidencije.CIPO_V1;
    if (recordPoint.CIPPEvd && recordPoint.CIPPEvd.length > 0)
      return EnumPoljaEvidencije.CIPP_V1;
    if (recordPoint.DezinfekcijaEvd && recordPoint.DezinfekcijaEvd.length > 0)
      return EnumPoljaEvidencije.Dezinfekcija_V1;
    if (recordPoint.DezinsekcijaEvd && recordPoint.DezinsekcijaEvd.length > 0)
      return EnumPoljaEvidencije.Dezinsekcija_V1;
    if (
      recordPoint.DezinsekcijaEvd_Kontrola &&
      recordPoint.DezinsekcijaEvd_Kontrola.length > 0
    ) {
      return EnumPoljaEvidencije.Dezinsekcija_Kontrola_V1;
    }
    if (
      recordPoint.DezinsekcijaEvd_Korekcija &&
      recordPoint.DezinsekcijaEvd_Korekcija.length > 0
    )
      return EnumPoljaEvidencije.Dezinsekcija_Korekcija_V1;
    if (recordPoint.DeratizacijaEvd && recordPoint.DeratizacijaEvd.length > 0)
      return EnumPoljaEvidencije.Deratizacija_V1;
    if (
      recordPoint.DeratizacijaEvd_Kontrola &&
      recordPoint.DeratizacijaEvd_Kontrola.length > 0
    )
      return EnumPoljaEvidencije.Deratizacija_Kontrole_V1;
    if (
      recordPoint.DeratizacijaEvd_Korekcija &&
      recordPoint.DeratizacijaEvd_Korekcija.length > 0
    )
      return EnumPoljaEvidencije.Deratizacija_Korekcije_V1;
    if (recordPoint.DezSrEvd && recordPoint.DezSrEvd.length > 0)
      return EnumPoljaEvidencije.DezSrEvd_V1;
    if (recordPoint.DobavljacEvd && recordPoint.DobavljacEvd.length > 0)
      return EnumPoljaEvidencije.DobavljacEvd_V1;
    if (recordPoint.DostavaEvd && recordPoint.DostavaEvd.length > 0)
      return EnumPoljaEvidencije.DostavaEvd_V1;
    if (recordPoint.EduZapEvd && recordPoint.EduZapEvd.length > 0)
      return EnumPoljaEvidencije.EduZapEvd_V1;
    if (recordPoint.MolEvd && recordPoint.MolEvd.length > 0)
      return EnumPoljaEvidencije.MolEvd_V1;
    if (recordPoint.OpremaEvd && recordPoint.OpremaEvd.length > 0)
      return EnumPoljaEvidencije.OpremaEvd_V1;
    if (recordPoint.OtpadEvd && recordPoint.OtpadEvd.length > 0)
      return EnumPoljaEvidencije.OtpadEvd_V1;
    if (recordPoint.PrijemRobeEvd && recordPoint.PrijemRobeEvd.length > 0)
      return EnumPoljaEvidencije.PrijemRobeEvd_V1;
    // if (recordPoint.SanEvd && recordPoint.SanEvd.length > 0)
    //   return EnumPoljaEvidencije.SanEvd_V1;
    if (recordPoint.TemperaturaEvd && recordPoint.TemperaturaEvd.length > 0)
      return EnumPoljaEvidencije.TemperaturaEvd_V1;
    if (
      recordPoint.TemperaturaOgranicenaEvd &&
      recordPoint.TemperaturaOgranicenaEvd.length > 0
    )
      return EnumPoljaEvidencije.TemperaturaOgranicenaEvd_V1;
    if (
      recordPoint.TemperaturaOgranicenaKKTEvd &&
      recordPoint.TemperaturaOgranicenaKKTEvd.length > 0
    )
      return EnumPoljaEvidencije.TemperaturaOgranicenaKKTEvd_V1;
    // Add more checks as needed for other Evd types
    if (
      recordPoint.TemperaturaKKTProizvodiEvd &&
      recordPoint.TemperaturaKKTProizvodiEvd.length > 0
    )
      return EnumPoljaEvidencije.TemperaturaKKTProizvodiEvd_V1;

    return null; // Return null if no Evd array has more than 0 items
  }

  function filterRecordPointsByConfigId(
    recordPoints: IRecordPointClass[],
    targetConfigId: number
  ): IRecordPointClass[] {
    return recordPoints.filter(
      (point) =>
        Number(point.RecordTraceConfig?.recordTraceConfigId) === targetConfigId
    );
  }

  const handleRecordPointClickList = (recordField: {
    recordTraceConfigId: number;
    title?: string;
    revizija?: string;
  }) => {
    if (queryEvidencijeData?.recordPointsByBranchId) {
      const filteredRps: IRecordPointClass[] = filterRecordPointsByConfigId(
        queryEvidencijeData?.recordPointsByBranchId,
        recordField?.recordTraceConfigId
      );

      if (filteredRps.length > 0) {
        const firstRecordPoint = filteredRps[0];
        setrecordTraceConfigIdState(
          Number(firstRecordPoint.RecordTraceConfig?.recordTraceConfigId)
        );
        const evdType = getEvdTypeFromRecordPoint(firstRecordPoint);
        if (evdType) {
          setSelectedRecordFieldList(evdType);
        } else {
          // TODO: Handle if no type found
        }
      } else {
        //TODO: handle if none filtered
      }
    }
  };

  const [filteredRecordPoints, setFilteredRecordPoints] = useState<
    IRecordPointClass[]
  >([]);

  const [filteredRecordPointsList, setFilteredRecordPointsList] = useState<
    IRecordPointClass[]
  >([]);

  // Use useEffect to generate userIdsVar when filteredRecordPoints changes
  useEffect(() => {
    // Initialize an array to store userIds
    const newuserIdsVar = [];

    // Loop through the array and extract userIds if CIPOEvd or CIPPEvd is filled out
    for (const recordPoint of filteredRecordPoints) {
      if (recordPoint.CIPOEvd && recordPoint.CIPOEvd.length > 0) {
        // CIPOEvd is filled out, extract userIds
        for (const cipoevd of recordPoint.CIPOEvd) {
          if (cipoevd.userId) {
            newuserIdsVar.push(cipoevd.userId);
          }
        }
      }

      if (recordPoint.CIPPEvd && recordPoint.CIPPEvd.length > 0) {
        // CIPPEvd is filled out, extract userIds
        for (const cippevd of recordPoint.CIPPEvd) {
          if (cippevd.userId) {
            newuserIdsVar.push(cippevd.userId);
          }
        }
      }
    }

    // Set the new userIdsVar
    setUserIds(newuserIdsVar);
    usersDataRefetch();
  }, [usersDataRefetch, selectedRecordField, filteredRecordPoints]);

  const extractAndFormatEvdDates = (points: IRecordPointClass[]) => {
    let evdDates: {
      date: Date;
      evd: any;
      point: IRecordPointClass;
      imePrezime: string;
    }[] = [];

    points.forEach((point) => {
      const evdProperties = Object.keys(point).filter((key) =>
        /Evd$|Kontrola$|Korekcija$|Proizvodi$/.test(key)
      );

      evdProperties.forEach((evdProperty) => {
        const evdArray = point[evdProperty as keyof IRecordPointClass];
        if (Array.isArray(evdArray)) {
          evdArray.forEach((evd: any) => {
            evdDates.push({
              date: new Date(evd.createdAt),
              evd,
              point,
              imePrezime: evd.imePrezime ? evd.imePrezime : evd.primalac,
            });
          });
        }
      });
    });

    evdDates.sort((a, b) => a.date.getTime() - b.date.getTime());

    return evdDates.map(({ date, evd, point, imePrezime }) => ({
      formattedDate: formatDate(date.toString()),
      imePrezime, // Store the creator's name
      point,
    }));
  };

  const renderGroupedPoints = (
    filteredRecordPointsList: IRecordPointClass[]
  ) => {
    const groupedPoints = groupByPointName(filteredRecordPointsList);

    // Initialize an array to hold all sorted dates, points, and creator names
    let allSortedEvdDates: {
      formattedDate: string;
      imePrezime: string;
      point: IRecordPointClass;
    }[] = [];

    // Iterate over the grouped points and collect all evd dates
    Object.entries(groupedPoints).forEach(([name, points]) => {
      const sortedEvdDates = extractAndFormatEvdDates(points);
      allSortedEvdDates = allSortedEvdDates.concat(sortedEvdDates);
    });

    // Render the collected and sorted evd dates along with creator names
    return (
      <div className="mt-2">
        {allSortedEvdDates.map(
          ({ formattedDate, imePrezime, point }, index) => (
            <div style={{ marginBottom: "1rem" }} key={index}>
              {formattedDate + " - " + imePrezime}
            </div>
          )
        )}
      </div>
    );
  };

  return (
    <>
      <Row className="mt-2">
        <Col>
          <Card>
            <Card.Body>
              <div
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <h1>{res.title}</h1>
              </div>
              <Row>
                {/* Label, Select branch, Button - Add branch */}
                {queryLoading ? (
                  <>
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </>
                ) : (
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <Col xs={12} md={6}>
                      <Form.Group className="mb-2">
                        <MobileSelect<BranchOption>
                          className="react-select react-select-container"
                          classNamePrefix="react-select"
                          options={categories}
                          id="product-category"
                          placeholder={res.branch.placeholder}
                          name="branch"
                          value={branchState}
                          onChange={(value) => {
                            handlebranchChange(value);
                          }}
                          noOptionsMessage={() => res.branch.notFound}
                        />
                      </Form.Group>
                    </Col>
                  </form>
                )}
              </Row>
              <Row>
                <form className="d-flex align-items-center mb-3">
                  <div className="input-group input-group-sm"></div>
                </form>
              </Row>
              <Row>
                {branchState && (
                  <>
                    <Row key={"dateRow"} style={{ paddingRight: 0 }}>
                      <Col
                        key={"dateCol2"}
                        xs={12}
                        md={3}
                        style={{ paddingRight: 0 }}
                      >
                        <FormInput
                          label={res.from}
                          type="date"
                          name="dateFrom"
                          containerClass={"mb-3"}
                          key={"dateFrom"}
                          min={config.DATES_EVIDENCIJE.YEARMIN}
                          max={config.DATES_EVIDENCIJE.MONTHMAX}
                          value={formatStateDates(startDate.toString())}
                          onChange={(e) => {
                            setstartDate(new Date(e.target.value));
                            // Clear shown list until user clicks button
                            setsanEvdsList([]);
                            setSanRequested(false);
                          }}
                        />
                      </Col>
                      <Col
                        key={"dateCol3"}
                        xs={12}
                        md={3}
                        style={{ paddingRight: 0 }}
                      >
                        <FormInput
                          label={res.to}
                          type="date"
                          name="dateTo"
                          containerClass={"mb-3"}
                          key={"dateTo"}
                          min={config.DATES_EVIDENCIJE.YEARMIN}
                          max={config.DATES_EVIDENCIJE.MONTHMAX}
                          value={formatStateDates(endDate.toString())}
                          onChange={(e) => {
                            setendDate(new Date(e.target.value));
                            // Clear shown list until user clicks button
                            setsanEvdsList([]);
                            setSanRequested(false);
                          }}
                        />
                      </Col>
                    </Row>

                    <Button
                      variant="info"
                      className="rounded-pill waves-effect waves-light mb-2 mx-2"
                      type="button"
                      onClick={() => getSanEvdOnly(branchState.value)}
                      style={{ width: "200px" }}
                    >
                      {res.sanEvdsList.button}
                    </Button>
                  </>
                )}
              </Row>

              <Row>
                {(errorById ||
                  errorQuery ||
                  errorByName ||
                  errorTree ||
                  errorUsers) && (
                  <Alert variant="danger" className="my-2">
                    {res.errorLoading}
                  </Alert>
                )}
              </Row>
              {showSanEvd && (
                <>
                  <Row>
                    <ul className="sitemap">
                      <li>
                        {queryEvidencijeLoading && sanRequested ? (
                          <div className="d-flex justify-content-center my-4">
                            <Spinner animation="border" role="status" />
                          </div>
                        ) : sanRequested && sanEvdsList.length > 0 ? (
                          <>
                            <p>{res.sanEvdsList.found}</p>
                            <hr />
                            {Array.from(
                              new Set(
                                sanEvdsList
                                  .filter(
                                    (item) => item?.RecordTraceConfig?.title
                                  )
                                  .map((item) => item.RecordTraceConfig?.title)
                              )
                            ).map((title, index) => {
                              const configItems = sanEvdsList.filter(
                                (item) =>
                                  item?.RecordTraceConfig?.title === title
                              );
                              return (
                                <div key={index}>
                                  <h4>
                                    {title}{" "}
                                    {
                                      configItems[0]?.RecordTraceConfig
                                        ?.revizija
                                    }
                                  </h4>
                                  {configItems.map(
                                    (recordPoint, rpIndex) =>
                                      recordPoint.SanEvd &&
                                      recordPoint.SanEvd.length > 0 && (
                                        <div key={rpIndex} className="mt-2">
                                          {recordPoint.SanEvd.map(
                                            (sanEvd, sanIndex) => (
                                              <div
                                                key={sanIndex}
                                                style={{ marginBottom: "1rem" }}
                                              >
                                                {formatDate(
                                                  sanEvd.updatedAt.toString()
                                                )}{" "}
                                                - {sanEvd.imePrezime}
                                              </div>
                                            )
                                          )}
                                        </div>
                                      )
                                  )}
                                  <hr />
                                </div>
                              );
                            })}
                            <div>
                              <Button
                                variant="info"
                                className="rounded-pill waves-effect waves-light my-4"
                                onClick={() =>
                                  handleDownloadPDFSanEvd(sanEvdsList)
                                }
                                style={{ width: "200px" }}
                              >
                                {res.sanEvdsList.download}
                              </Button>
                            </div>
                          </>
                        ) : sanRequested ? (
                          <p>{res.sanEvdsList.notFound}</p>
                        ) : null}
                      </li>
                    </ul>
                  </Row>
                </>
              )}
              {showItems && (
                <>
                  <Row>
                    <ul className="sitemap">
                      <li>
                        {items && showItems && <SiteMapMenu item={items} />}
                      </li>
                    </ul>
                  </Row>
                  {recordPointsState && recordPointsState.length > 0 && (
                    <Row>
                      <hr />
                      {/* TODO: Add Dates Pick - Srediti ovdje title design itd, dodati uz name odabir i po datumu  */}

                      <h3>{res.evidencije.title}</h3>

                      {recordFieldsTypes.map((recordPoint, index) => (
                        <div
                          key={index}
                          onClick={() => handleRecordPointClick(recordPoint)}
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          <p>
                            {recordPoint.title + " " + recordPoint.revizija}
                          </p>
                        </div>
                      ))}

                      {selectedRecordField &&
                        filteredRecordPoints &&
                        filteredRecordPoints.length > 0 && (
                          <>
                            <div>
                              <hr />
                              <h4>
                                {
                                  filteredRecordPoints[0].RecordTraceConfig
                                    ?.title
                                }{" "}
                                {
                                  filteredRecordPoints[0].RecordTraceConfig
                                    ?.revizija
                                }
                              </h4>
                              {renderGroupedPoints(filteredRecordPoints)}
                            </div>
                            <div>
                              <Button
                                variant="info"
                                className="rounded-pill waves-effect waves-light my-4"
                                onClick={handleDownloadPDF}
                                style={{ width: "200px" }}
                              >
                                {res.evidencije.pojedinacneDownload}
                              </Button>
                            </div>
                          </>
                        )}
                    </Row>
                  )}
                </>
              )}
              {/* Liste Evidencija */}
              {showItemsLista && (
                <>
                  <hr />
                  <h3>{res.evidencije.title}</h3>
                  {recordFieldsListTypes.map((recordPoint, index) => (
                    <div
                      key={index}
                      onClick={() => handleRecordPointClickList(recordPoint)}
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      <p>{recordPoint.title + " " + recordPoint.revizija}</p>
                    </div>
                  ))}

                  {selectedRecordFieldList &&
                    filteredRecordPointsList &&
                    filteredRecordPointsList.length > 0 && (
                      <>
                        <div>
                          <hr />
                          <h4>
                            {filteredRecordPointsList &&
                              filteredRecordPointsList[0].RecordTraceConfig
                                ?.title}{" "}
                            {filteredRecordPointsList &&
                              filteredRecordPointsList[0].RecordTraceConfig
                                ?.revizija}
                          </h4>

                          {renderGroupedPoints(filteredRecordPointsList)}
                        </div>
                        <div>
                          <Button
                            variant="info"
                            className="rounded-pill waves-effect waves-light my-4"
                            onClick={handleDownloadPDFList}
                            style={{ width: "200px" }}
                          >
                            {res.evidencije.zbirniDownload}
                          </Button>
                        </div>
                      </>
                    )}
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default ListaSanEvd;
